import kebabCase from 'lodash/kebabCase';
import deburr from 'lodash/deburr';

function normalizeString(str: string = '') {
  return kebabCase(deburr(str)).replace(/-/g, '');
}

export function isDescriptionDifferent(description: string | undefined, name: string | undefined) {
  return !!description && normalizeString(name) !== normalizeString(description);
}
